<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "JBProposalReferences",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label:
						"23. Unless proposing for renewal, give two references FROM YOUR TRADE:",
					component: "longText",
					bindTo: "case.facts.tradeReferences"
				}
			]
		}
	}
}
</script>
